export default __webpack_public_path__ + "static/media/Research3.85f0fd55.png";